// FAQs.js
import React, { useState } from 'react';
import Header from './Header';
import { chainConnectionsIds, CHAIN_CONNECTIONS } from '../config';
import Carousel from './Carousel';
import '../Styles/FAQs.css';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(-1);
  const supportedNetworks = Object.values(CHAIN_CONNECTIONS).map(chain => chain.networkName);

  const supportedBlockchains = chainConnectionsIds.map(id => CHAIN_CONNECTIONS[id].networkName).join(", ");
  const faqs = [
    {
      question: "1.- What is SurferMonkey's Playground?",
      answer: "SurferMonkey's Playground is a platform designed to showcase our technology for agnostic anonymous blockchain transactions that are compliant with regulators. The Playground supports cross-chain transfers and functions as an agnostic anonymous multi-chain zkMixer.",
    },
    {
      question: "2.- Which blockchains does SurferMonkey's Playground support?",
      answer: `${supportedBlockchains}.`,
    },
    {
      question: "3.- How do I start using SurferMonkey's Playground?",
      answer: "To begin, connect to MetaMask and select one of our supported networks as your origin blockchain. Follow the step-by-step process for DACT deposit and DACT withdraw, and you're all set.",
    },
    {
      question: "4.- Are my transactions private and anonymous?",
      answer: "Yes, the transactions are anonymous and private. No additional initialization steps or fees are required. As of now and to protect our system from copycats in our initial steps, all data structures are created in our system. In a more mature state of the Playground, we will migrate this towards the client side.",
    },
    {
      question: "5.- Where is the ZKP generated, and how long does it take?",
      answer: "The ZKP is generated on the client side, meaning in the user's browser. The process to generate the proof can range from 1.5 seconds to 2 seconds, and in some cases, up to 8 seconds."
    },
    {
      question: "6.- What protocol does SurferMonkey use for its privacy and anonymity features?",
      answer: (
        <>
          SurferMonkey Playground is utilizing the <b>Distributed Anonymous Compliance Technology (DACT)</b>. Previously known as {" "}
          <a href="https://arxiv.org/abs/2210.13242" target="_blank" rel="noreferrer" className="link">
            Decentralized Agnostic Cross-Chain Transfer
          </a>{" "}
          protocol, the technology has evolved to better address the needs of privacy, anonymity, and compliance, making it a more robust and advanced solution for our ecosystem.
        </>
      )
    },
    {
      question: "7.- How do zkMiners work, and how often do they update transactions?",
      answer: "zkMiners capture transactions, create the Global Merkle Tree, and update the Root in the DACT Global Mixers. The update frequency depends on network demand, ranging from 3-5 minutes during high demand to 30 minutes during low demand or passive mode.",
    },
    {
      question: "8.- What is the Signing Engine, and how does it contribute to system security?",
      answer: "The Signing Engine verifies and signs transactions, increasing system security. It also considers the ReorgDepth of each blockchain, ensuring the integrity of transactions. This signature can be overridden by each dApp connected to the SurferMonkey ecosystem, allowing them to implement their own distributed signature, such as a TSS (Threshold Signature Scheme). This gives dApps the option to bootstrap easily with SurferMonkey's stamp and migrate to their own TSS as they mature. As SurferMonkey's Signing Engine grows, it will support TSS as well.",
    },
    {
      question: "9.- How does SurferMonkey's Playground achieve compliance with regulators?",
      answer: "SurferMonkey's Playground includes a Cryptographic window that allows financial regulators to track transactions at all times. This feature ensures compliance with regulatory standards.",
    },
    {
      question: "10.- What are the transaction costs for users and zkMiners?",
      answer: "Transaction costs on SurferMonkey's Playground are low for both users and zkMiners, making the platform affordable and accessible.",
    },
    {
      question: "11.- What happens if I lose my data structures?",
      answer: "It is crucial to preserve your data structures, as losing them would result in the permanent loss of your transaction.",
    },
    {
      question: "12.- How can I get support if I have questions or encounter issues?",
      answer: "For support, please contact our team through the website, email, or social media channels. We're here to help!",
    },
    {
      question: "13.- Can other dApps and zkMiners connect to the SurferMonkey ecosystem?",
      answer: "Absolutely! Other dApps can already connect to our ecosystem. We encourage interested parties to reach out to us for more information on integrating their solutions with the SurferMonkey network. As for zkMiners, we are actively working on expanding our network to include additional zkMiners in the near future. This collaboration will help create a more robust and diverse community, fostering innovation within the blockchain space."
    },
    {
      question: "14.- Are there any known issues with the platform?",
      answer: "Currently, ecParing Precompile isn't supported on chains like Polygon ZkEVM, ZkSync Era, and Futurverse Porcini, which means ZKP Smart Contract verification isn't available for now. However, their respective teams are actively working on this implementation.\n\nAdditionally, depending on the RPC providers, false negatives might occur. This can result in the UI indicating a transaction failure when it has actually succeeded. Always cross-check with block scanners for verification. Note: False positives are not possible in the UI since a success message only appears if confirmed by the RPC provider."
    }
  ];

  const handleQuestionClick = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <div className="App poppins">
      <Header />
      <div className='titleReg'>
        <h1 className="titleRegLetters">
          FAQs
        </h1>
      </div>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <div key={index} className="faq" onClick={() => handleQuestionClick(index)}>
            <div className="faq-question" >{faq.question}</div>
            {openIndex === index && <div className="faq-answer">{faq.answer}</div>}
          </div>
        ))}
      </div>
      <div className='AllNetIds'>
        <Carousel supportedNetworks={supportedNetworks} velocity={2} />
      </div>
    </div>
  );
};

export default FAQs;